import * as React from "react"

import { cn } from "@/lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 disabled:cursor-not-allowed disabled:opacity-50 resize-y border-[rgba(15,23,42,0.09)] bg-white text-[#101828] shadow-[var(--shadow-card)] placeholder:text-[#576274] focus:border-[rgba(147,51,245,0.4)] focus:ring-[rgba(59,130,246,0.15)] dark:border-indigo-300/20 dark:bg-slate-950/45 dark:text-white dark:shadow-none dark:placeholder:text-slate-400 dark:focus:border-violet-400/70 dark:focus:ring-violet-400/25",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
